/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Tabs_BuildsInputs */

const id_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const ms_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan`)
};

const da_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const de_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const en_us2_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const es_es2_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones`)
};

const es_mx2_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones`)
};

const fil_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Build`)
};

const fr_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilations`)
};

const it_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const hu_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-ek`)
};

const nl_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const no_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const pl_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacje`)
};

const pt_br2_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const pt_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilações`)
};

const ro_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilări`)
};

const fi_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversiot`)
};

const sv_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggen`)
};

const vi_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng`)
};

const tr_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapılar`)
};

const cs_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sestavení`)
};

const bg_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компилации`)
};

const ru_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сборки`)
};

const uk_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Збірки`)
};

const ar_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البنيات`)
};

const hi_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड`)
};

const th_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์`)
};

const ja_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルド`)
};

const zh_cn2_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建版本`)
};

const zh_hant1_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置版本`)
};

const ko_items_tabs_builds = /** @type {(inputs: Items_Tabs_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드`)
};

/**
* | output |
* | --- |
* | "Builds" |
*
* @param {Items_Tabs_BuildsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_tabs_builds = /** @type {((inputs?: Items_Tabs_BuildsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Tabs_BuildsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_tabs_builds(inputs)
	if (locale === "ms") return ms_items_tabs_builds(inputs)
	if (locale === "da") return da_items_tabs_builds(inputs)
	if (locale === "de") return de_items_tabs_builds(inputs)
	if (locale === "en-US") return en_us2_items_tabs_builds(inputs)
	if (locale === "es-ES") return es_es2_items_tabs_builds(inputs)
	if (locale === "es-MX") return es_mx2_items_tabs_builds(inputs)
	if (locale === "fil") return fil_items_tabs_builds(inputs)
	if (locale === "fr") return fr_items_tabs_builds(inputs)
	if (locale === "it") return it_items_tabs_builds(inputs)
	if (locale === "hu") return hu_items_tabs_builds(inputs)
	if (locale === "nl") return nl_items_tabs_builds(inputs)
	if (locale === "no") return no_items_tabs_builds(inputs)
	if (locale === "pl") return pl_items_tabs_builds(inputs)
	if (locale === "pt-BR") return pt_br2_items_tabs_builds(inputs)
	if (locale === "pt") return pt_items_tabs_builds(inputs)
	if (locale === "ro") return ro_items_tabs_builds(inputs)
	if (locale === "fi") return fi_items_tabs_builds(inputs)
	if (locale === "sv") return sv_items_tabs_builds(inputs)
	if (locale === "vi") return vi_items_tabs_builds(inputs)
	if (locale === "tr") return tr_items_tabs_builds(inputs)
	if (locale === "cs") return cs_items_tabs_builds(inputs)
	if (locale === "bg") return bg_items_tabs_builds(inputs)
	if (locale === "ru") return ru_items_tabs_builds(inputs)
	if (locale === "uk") return uk_items_tabs_builds(inputs)
	if (locale === "ar") return ar_items_tabs_builds(inputs)
	if (locale === "hi") return hi_items_tabs_builds(inputs)
	if (locale === "th") return th_items_tabs_builds(inputs)
	if (locale === "ja") return ja_items_tabs_builds(inputs)
	if (locale === "zh-CN") return zh_cn2_items_tabs_builds(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_tabs_builds(inputs)
	return ko_items_tabs_builds(inputs)
});
export { items_tabs_builds as "items.tabs.builds" }